__turbopack_context__.v({
  "root": "CompareTable-module-scss-module__XtJojW__root",
});
